import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TableService {
  private readonly sync: Subject<void> = new Subject<void>();

  public addUnSelectAll = (): void => this.sync.next();

  public onUnSelectAll = this.sync.asObservable();
}
